import React from 'react'

function RedChatIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            d="M0 0H24V24H0z"
            data-name="Rectangle 9308"
            transform="translate(305 1608)"
          ></path>
        </clipPath>
      </defs>
      <g clipPath="url(#clip-path)" data-name="Mask Group 548" transform="translate(-305 -1608)">
        <g data-name="Group 57203" transform="translate(306 1609)">
          <g data-name="Group 57201">
            <g transform="translate(.615 .537)">
              <g data-name="01-like">
                <path
                  fill="#fe5f55"
                  d="M19.77-1v20.03a.74.74 0 01-1.15.615L13.608 16.3H-1V2.112-1z"
                  data-name="Path 6875"
                  transform="translate(1 1)"
                ></path>
              </g>
            </g>
            <g data-name="chat">
              <g data-name="01-like">
                <path
                  fill="#fe5f55"
                  d="M21-1V20.22a.783.783 0 01-1.218.652l-5.309-3.543H-1V2.3-1zM19.433.567H.567V15.759H14.71a.783.783 0 01.435.132l4.288 2.861V.567z"
                  data-name="Path 6875"
                  transform="translate(1 1)"
                ></path>
              </g>
              <path
                fill="#fff"
                d="M8.682.8H0V-1h8.682z"
                data-name="Path 63223"
                transform="translate(6.475 6.788)"
              ></path>
              <path
                fill="#fff"
                d="M4.36.8h-6.85V-1h6.85z"
                data-name="Path 63224"
                transform="translate(10.798 11.369)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default RedChatIcon
